module.exports = __webpack_public_path__ + "static/img/image66.5393d366.png";